import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

type Props = {
  onDismiss: () => void;
  className?: string;
};

export const MagicEditMaskHintBanner = ({ onDismiss, className }: Props) => {
  const { t } = useTranslation();

  return (
    <output
      className={cn(
        'absolute inset-x-0 bottom-0 z-20 flex items-center justify-between gap-3 bg-slate-900/85 px-3 py-2.5 text-white sm:px-4 sm:py-3',
        className
      )}
    >
      <p className="text-xs font-medium leading-snug sm:text-sm">
        {t('magic-edit-draw-mask-hint')}
      </p>
      <Button
        type="button"
        size="sm"
        className="h-8 shrink-0 rounded-sm px-4 text-xs font-semibold sm:text-sm"
        color="primary-light"
        variant="contained"
        onClick={onDismiss}
      >
        {t('ok')}
      </Button>
    </output>
  );
};
